import { render, staticRenderFns } from "./MixinSkills.vue?vue&type=template&id=2b00d473&scoped=true&lang=html&"
import script from "./MixinSkills.vue?vue&type=script&lang=js&"
export * from "./MixinSkills.vue?vue&type=script&lang=js&"
import style0 from "./MixinSkills.vue?vue&type=style&index=0&id=2b00d473&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00d473",
  null
  
)

export default component.exports